<template>
  <div class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-6" v-show="!show">
          <h1>Set your password</h1>

          <b-field label="First name">
            <b-input type="text" v-model="user.FirstName" placeholder="First Name"></b-input>
          </b-field>

          <b-field label="Last name">
            <b-input type="text" v-model="user.LastName" placeholder="Last Name"></b-input>
          </b-field>

          <b-field label="Organisation Name">
            <b-input type="text" v-model="user.OrganizationName" placeholder="Your Organisation's Name"></b-input>
          </b-field>

          <b-field label="Organisation Address">
            <b-input type="text" v-model="user.OrganizationAddress" placeholder="Your Organisation's Address"></b-input>
          </b-field>

          <b-field label="Password">
            <b-input type="password" v-model="password" placeholder="New Password"></b-input>
          </b-field>
          <input type="text" style="display:none" id="NoAutofill" />

          <b-field label="Confirm password">
            <b-input type="password" v-model="confirmPassword" placeholder="Confirm Password"></b-input>
          </b-field>

          <b-button class="is-primary" @click="setPassword">Submit</b-button>
        </div>
        <div v-show="show">
          <div @click="sendWelcome()" class="button has-text-centered">
            <i class="fad fa-envelope pointer-cursor"></i>&nbsp;Resend welcome email
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import termsAndConditions from '@/components/modals/termsAndConditions.vue';
  export default {
    props: {
      id: String,
      token: String
    },
    data() {
      return {
        user: {},
        password: '',
        confirmPassword: '',
        show: false
      }
    },
    created() {
      this.$http.get("api/user/" + this.id)
        .then(resp => {
          this.user = resp.data;
        }).catch(err => {
          console.error(err);
        });
    },
    methods: {
      async sendWelcome() {
        await this.$http.get("api/user/sendReset/" + this.id)
          .then(resp => {
            if (resp.data) {
              this.$buefy.notification.open({
                duration: 6000,
                message: "Welcome email sent.",
                type: 'is-success',
              })
            }
            else {
              this.$buefy.notification.open({
                duration: 6000,
                message: "Welcome email failed to send.",
                type: 'is-danger',
              })
            }
            this.$router.push("/login");
          })
      },
      cardModal() {
        this.$buefy.modal.open({
          parent: this,
          component: termsAndConditions,
          hasModalCard: true,
        })
      },
      async setPassword() {
        if (this.password != this.confirmPassword) {
          this.$buefy.notification.open({
            message: "Please make your passwords match.",
            type: "is-danger",
          });
        }
        else if (this.password.length <= 6) {
          this.$buefy.notification.open({
            message: "Please make sure the length of your passsword is more than 6 characters.",
            type: "is-danger",
          });
        }
        else if (this.user.FirstName && this.user.LastName && this.password && this.confirmPassword && this.user.OrganizationName && this.user.OrganizationAddress) {
          await this.$http.post("api/user/setPasswordNewUser", { user: this.user, password: this.password, token: this.token })
            .then(resp => {
              if (resp.data == "Success") {
                this.$buefy.notification.open({
                  message: "Successfully updated password.",
                  type: "is-success",
                });
                this.$router.push({ name: 'loginFlow', params: { email: this.user.Email } });
              }
              else {
                var message = "Something went wrong. Please try again later.";

                if (resp.data == "InvalidToken") {
                  message = "Your token has expired.  Please use the button to send yourself a new link.";
                  this.show = true;
                }
                else if (resp.data == "PasswordTooShort") {
                  message = "You password must be at least 6 characters long";
                }

                this.$buefy.notification.open({
                  message: message,
                  type: "is-danger",
                });
              }
            });
        }
        else {
          this.$buefy.notification.open({
            message: "Please fill out all fields",
            type: "is-danger",
          });
        }

      }
    }
  }
</script>
